module.exports = __webpack_public_path__ + "assets/38b9cc34e3a89f2532c2191fa0e09d12.png";